// A compact "Book activities with" partner row that lives in the hero, under
// the CTA. Just muted wordmarks, no cards/animation, so it reads as a trust
// signal rather than an ad. Links are affiliate links (rel="sponsored", new
// tab). Drop an SVG/PNG into /public/partners and set `logoSrc` to swap a
// wordmark for real logo art.
type Partner = {
  name: string
  blurb: string
  href: string
  logoSrc?: string | null
}

const PARTNERS: Partner[] = [
  {
    name: `Klook`,
    blurb: `Tours & activities`,
    href: `https://klook.tpo.lu/A3hBN2Q5`,
    logoSrc: null,
  },
  {
    name: `KKday`,
    blurb: `Experiences worldwide`,
    href: `https://kkday.tpo.lu/Ee2nEPaf`,
    logoSrc: null,
  },
  {
    // Expedia runs through Partnerize (network "pz"): prf.hn credits our camref,
    // then forwards to the destination URL. Same camref as the on-page Expedia
    // search widget (see ExpediaWidget.tsx, data-camref="1101l5L4q6").
    name: `Expedia`,
    blurb: `Hotels & flights`,
    href: `https://prf.hn/click/camref:1101l5L4q6/destination:https://www.expedia.com`,
    logoSrc: null,
  },
]

export function TravelPartners() {
  return (
    <div aria-label="Travel partners" className="flex flex-col gap-2.5 pt-1">
      <p className="text-[11px] font-semibold uppercase tracking-widest text-muted-foreground/70">
        Our Travel Partners
      </p>
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
        {PARTNERS.map((partner) => (
          <a
            key={partner.name}
            href={partner.href}
            target="_blank"
            rel="sponsored noopener noreferrer"
            aria-label={`${partner.name} — ${partner.blurb}`}
            className="text-lg font-bold tracking-tight text-muted-foreground/60 transition-colors hover:text-foreground"
          >
            {partner.logoSrc ? (
              <img
                src={partner.logoSrc}
                alt={partner.name}
                height={24}
                className="h-6 w-auto object-contain opacity-70 transition-opacity hover:opacity-100"
                loading="lazy"
                decoding="async"
              />
            ) : (
              partner.name
            )}
          </a>
        ))}
      </div>
      <p className="text-[11px] text-muted-foreground/60">
        We may earn a commission from our partners.
      </p>
    </div>
  )
}
